import { render, staticRenderFns } from "./allCoutseList.vue?vue&type=template&id=07dc9064&scoped=true"
import script from "./allCoutseList.vue?vue&type=script&lang=js"
export * from "./allCoutseList.vue?vue&type=script&lang=js"
import style0 from "../asset/css/list.scss?vue&type=style&index=0&id=07dc9064&prod&lang=scss&scoped=true&external"
import style1 from "./allCoutseList.vue?vue&type=style&index=1&id=07dc9064&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07dc9064",
  null
  
)

export default component.exports